import { useCallback } from 'react';

import { useTranslate } from './use-locale';

/**
 * The city catalog the API stores ids from (`GET /cities`), as names.
 *
 * `city` on a talent, an organization or a registration is a catalog id —
 * `riyadh`, never «الرياض» — and the console shows the name in the admin's
 * language. A value the catalog does not know (rows written before it existed,
 * or a city added on the server before it is added here) is shown as stored,
 * which beats a blank in a review queue. The ids mirror `city-catalog.ts` in
 * Marzouki-Backend and the mobile picker; add to all three together.
 */
export function useCityLabel(): (city: string | null | undefined) => string | null {
  const t = useTranslate();

  return useCallback(
    (city) => {
      if (!city) return null;
      const key = `cities.${city}`;
      const label = t(key);
      return label === key ? city : label;
    },
    [t],
  );
}
